import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

// Generic event structure (no source)
export type PubSubEvent<T = any> = {
  type: string;
  payload?: T;
  timestamp: number;
};

// Core communication atom
export const pubSubEventAtom = atomWithReset<PubSubEvent | null>(null);

// Publisher atom
export const publishEventAtom = atom(null, (_get, set, event: Omit<PubSubEvent, 'timestamp'>) => {
  const fullEvent: PubSubEvent = {
    ...event,
    timestamp: Date.now()
  };
  set(pubSubEventAtom, fullEvent);
});